import React, { Component } from 'react'
import { observer } from 'mobx-react'
import '../../assets/css/page.css'

import SkipNumericOption from './SkipNumericOption'
import SkipQuestionOption from './SkipQuestionOption'
import SkipDateOption from './SkipDateOption'

@observer
class SkipPageOption extends Component {
    getSkipOption = () => {
        const {
            group,
            name,
            origQuestion,
            store,
            index,
            triggerIndex,
            changeTriggerOperator,
            removeTrigger,
        } = this.props
        const id = `skipquestionoption_${group.id}`
        const isDate = group.triggers.some(({ condition }) => condition.kind === 'Date')
        const isNumeric = group.triggers.some(({ condition }) => condition.kind === 'QuestionHasNumericResponse')
        let elem = null
        if (isNumeric) {
            elem = (
                <SkipNumericOption
                    group={group}
                    triggerIndex={triggerIndex}
                    store={store}
                    removeTrigger={removeTrigger}
                    question={group}
                    index={index}
                />
            )
        } else if (isDate) {
            elem = (
                <SkipDateOption
                    group={group}
                    triggerIndex={0}
                    removeTrigger={removeTrigger}
                    index={index}
                />
            )
        } else {
            elem = (
                <SkipQuestionOption
                    store={store}
                    key={id}
                    group={group}
                    question={group}
                    name={name}
                    index={index}
                    triggerIndex={triggerIndex}
                    changeTriggerOperator={changeTriggerOperator}
                    origQuestion={origQuestion}
                    removeTrigger={removeTrigger}
                />
            )
        }

        return elem
    }

    render() {
        const {
            group,
            triggerIndex,
        } = this.props
        console.log(`skipquestionoption_ ${triggerIndex} ${JSON.stringify(group, null, 4)}`)
        return (
            this.getSkipOption()
        )
    }
}

export default SkipPageOption
